import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Layout from '../components/layout'
import ContestContent from '../components/ContestContent'

const worksQuery = graphql`
  query ContestsQuery {
    works: allContestsJson {
      edges {
        work: node {
          title,
          category,
          collaborators,
          client,
          year,
          url,
          featured,
          image {
            src
            sources {
              media
              srcset
            }
          }
        }
      }
    }
  }
`

export default ({ location }) =>
  <Layout location={location}>
    <StaticQuery
      query={worksQuery}
      render={data => <ContestContent data={data} />}
    />
  </Layout>
